var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcChevronUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.42549 7.86934C9.25192 8.0429 8.97052 8.0429 8.79695 7.86934L6.00011 5.0725L3.20327 7.86934C3.0297 8.0429 2.74829 8.0429 2.57473 7.86934C2.40116 7.69577 2.40116 7.41436 2.57473 7.2408L5.68584 4.12969C5.85941 3.95612 6.14081 3.95612 6.31438 4.12969L9.42549 7.2408C9.59906 7.41436 9.59906 7.69577 9.42549 7.86934Z",
    fill: "#3C6CD6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcChevronUp);
export default __webpack_public_path__ + "static/media/ic-chevron-up.a5e60ab5534a8b19b4f0736e05b62a26.svg";
export { ForwardRef as ReactComponent };